import React from 'react';
import { useConfig } from './config';

const CookiesPolicy = () => {
  const config = useConfig();
  const lastUpdated = "November 14, 2024";

  return (
    <main>
      <div className="max-w-3xl mx-auto px-4 py-6 sm:px-6 lg:px-8 bg-white rounded-lg shadow-xl my-8 relative">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-40 h-40 bg-blue-500 rounded-full filter blur-3xl opacity-5 -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-40 h-40 bg-red-500 rounded-full filter blur-3xl opacity-5 translate-y-1/2 -translate-x-1/2"></div>
        
        {/* Content */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4 relative inline-block">
          Cookie Policy
          <span className="absolute -bottom-1 left-0 right-0 h-1 bg-gradient-to-r from-red-500 to-blue-500 rounded-full"></span>
        </h1>
        
        <p className="text-sm text-gray-600 mb-6">
          <strong>Last updated:</strong> {lastUpdated}
        </p>

        <p className="mb-4 text-gray-700">
          At <strong>{config.siteName}</strong>, we use cookies and similar technologies to improve user experience, personalize content and ads, provide social media features, and analyze traffic on our website. This Cookie Policy explains what cookies are, how we use them, and how you can manage them.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          1. Consent and Choices
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          When you first visit our website, you will be asked to consent to the use of cookies via a pop-up banner. You can change your preferences at any time in the cookie settings on our website.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          2. Use of Third-Party Cookies
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          We use third-party cookies, such as Google Analytics and Google Ads, to measure and improve our performance and to provide relevant advertising. These cookies may collect data about your browsing behavior on our and other websites.
        </p>
        
        <p className="mb-4 text-gray-700">
          For more information about how Google uses collected data, please refer to Google's privacy policies: <a href="https://policies.google.com/technologies/ads" className="text-blue-600 hover:text-blue-800 relative group">
            Google Ads & Privacy
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
          </a>.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          3. Managing or Disabling Cookies
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          You can configure your browser to reject some or all cookies. You can also opt out of interest-based advertising at the following page:
          <a href="https://adssettings.google.com/authenticated" className="text-blue-600 hover:text-blue-800 ml-1 relative group">
            Google Ads Settings
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
          </a>.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          4. Changes to Our Policy
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          We reserve the right to update this Cookie Policy at any time. We encourage users to check this page regularly.
        </p>
      </div>
    </main>
  );
};

export default CookiesPolicy;